<div class="container-fluid">
  <div id="map">
    <div class="overlay dark load" *ngIf="loader" style="width: 100%; height: 550px;">
      <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      <div class="mask text-light d-flex justify-content-center flex-column text-center" style="background-color: rgba(0, 0, 0, 0.5)">
        <h4>Loading Pops Location</h4>
      </div>
    </div>
    
  </div>

</div>


